import {
  Flex,
  FormLabel,
  Input,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';

import React from 'react';

export default function Default(props) {
  const { id, label, extra, placeholder, type, mb, value, ...rest } = props;
  // Chakra Color Mode
  const textColorPrimary = useColorModeValue('secondaryGray.900', 'white');
  const inputBorder = useColorModeValue('gray.300', 'navy.600');

  return (
    <Flex direction="column" mb={mb ? mb : '5px'}>
      <FormLabel
        display="flex"
        // ms='10px'
        htmlFor={id}
        fontSize="sm"
        color={textColorPrimary}
        fontWeight="bold"
        _hover={{ cursor: 'pointer' }}
      >
        {label}
        <Text fontSize="sm" fontWeight="400" ms="2px">
          {extra}
        </Text>
      </FormLabel>
      <Input
        {...rest}
        overflowX="auto"
        textAlign={'center'}
        type={type}
        id={id}
        variant="main"
        p={2}
        size="sm"
        borderRadius="0.5rem"
        paddingX={2}
        value={value}
        paddingY={2}
        fontSize="sm"
        borderColor={inputBorder}
        placeholder={placeholder}
        _placeholder={{ fontWeight: '400', color: 'secondaryGray.600' }}
      />
    </Flex>
  );
}
